export enum TabType {
  positions = "positions",
  transactionHistory = "transactionHistory",
}
